import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './OpeningHoursPopup.scss';

const OpeningHoursPopup = () => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        // Check if popup was already closed in this session
        const popupClosed = localStorage.getItem('openingHoursPopupClosed');
        if (!popupClosed) {
            // Show popup after a short delay for better UX
            const timer = setTimeout(() => {
                setIsOpen(true);
            }, 500);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleClose = () => {
        setIsOpen(false);
        // Remember that popup was closed (for this session)
        localStorage.setItem('openingHoursPopupClosed', 'true');
    };

    if (!isOpen) return null;

    return (
        <div className="opening-hours-popup-overlay" onClick={handleClose}>
            <div className="opening-hours-popup" onClick={(e) => e.stopPropagation()}>
                <button className="popup-close-btn" onClick={handleClose} aria-label="Close">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                <div className="popup-content">
                    <div className="popup-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
                            <path d="M12 6V12L16 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                    </div>
                    <h2 className="popup-title">{t('openingHoursPopup.title')}</h2>
                    <div className="popup-hours">
                        <div className="hours-section">
                            <div className="hours-day">{t('openingHoursPopup.mondayThursday')}</div>
                            <div className="hours-time">{t('openingHoursPopup.mondayThursdayHours1')}</div>
                            <div className="hours-time">{t('openingHoursPopup.mondayThursdayHours2')}</div>
                        </div>
                        <div className="hours-section">
                            <div className="hours-day">{t('openingHoursPopup.friday')}</div>
                            <div className="hours-time">{t('openingHoursPopup.fridayHours')}</div>
                        </div>
                        <div className="hours-section">
                            <div className="hours-day">{t('openingHoursPopup.saturday')}</div>
                            <div className="hours-time">{t('openingHoursPopup.saturdayHours')}</div>
                        </div>
                        <div className="acute-section">
                            <div className="acute-title">{t('openingHoursPopup.acuteTitle')}</div>
                            <div className="acute-time">{t('openingHoursPopup.acuteHours')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OpeningHoursPopup;

